"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 6/12/2017.
 */
var PathUtil = /** @class */ (function () {
    function PathUtil() {
    }
    PathUtil.PATH = "app/shared/mock/";
    return PathUtil;
}());
exports.PathUtil = PathUtil;
//# sourceMappingURL=path.util.js.map